import { Injectable } from '@angular/core';
import { EndUserLicenseAgreementItem } from '../models/end-user-license-agreement.model';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import {
  EndUserLicenseAgreementItemState,
  EndUserLicenseAgreementItemStateModel,
} from './end-user-license-agreement-item.state';
import {
  EndUserLicenseAgreementItemInitialState,
  EndUserLicenseAgreementItemLoad,
  EndUserLicenseAgreementItemPublish,
  EndUserLicenseAgreementItemSave,
} from './end-user-license-agreement-item.actions';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../../../../ui-kit/confirmation-dialog/confirmation-dialog.component';

@Injectable({ providedIn: 'root' })
export class EndUserLicenseAgreementItemFacade implements LoadDataFacade, SetInitialStateFacade {
  eulaItemData$: Observable<EndUserLicenseAgreementItemStateModel> = this.store.select(
    EndUserLicenseAgreementItemState.getState,
  );
  eulaItemId$: Observable<number> = this.store.select(EndUserLicenseAgreementItemState.getEulaItemId);
  loaded$: Observable<boolean> = this.store.select(EndUserLicenseAgreementItemState.getLoaded);

  constructor(private store: Store) {}

  loadAll(eulaItemId: number): void {
    this.store.dispatch(new EndUserLicenseAgreementItemLoad(eulaItemId));
  }

  saveEulaItem(data: Partial<EndUserLicenseAgreementItem>): void {
    this.store.dispatch(new EndUserLicenseAgreementItemSave(data));
  }

  publishEulaItem(eulaItemId: number, dialog: MatDialogRef<ConfirmationDialogComponent>): void {
    this.store.dispatch(new EndUserLicenseAgreementItemPublish({ eulaItemId, dialog }));
  }

  setInitialState(): void {
    this.store.dispatch(new EndUserLicenseAgreementItemInitialState());
  }
}
